import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import Button from "react-bootstrap-button-loader";
import {
  mainLogin,
  resetSession,
  openEventChooser,
  initiateCreateEvent,
  logout,
  checkClientuserlimitandexpiry,
} from "Actions";
import { DEVELOPMENT_TYPE } from "Constants";
import LoginErrorBar from "./errorbar";
import EventChooser from "EventChooser";
import ErrorBar from "ReduxErrorBar";
import LocaleStrings from "Languages";

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      showerror: false,
      alertMessage: "",
    };
  }
  componentDidMount() {
    // this.props.logout(this.props.session);
  }

  componentWillUnmount() {
    this.setState({
      ...this.state,
      loading: false,
      showerror: false,
      alertMessage: "",
    });
  }

  componentWillMount() {
    let { isLoggedIn, user } = this.props;
    // console.log("login isLoggedIn :- ", isLoggedIn);
    // console.log("login user :- ", user);
    // if (this.props.isLoggedIn === true) {
    //   this.props.history.push("/dashboard");
    // }
    if (isLoggedIn === true && user.totalAdminEvents > 0) {
      this.props.history.push("/dashboard");
    } else if (isLoggedIn === true && user.totalAdminEvents == 0) {
      setTimeout(() => {
        this.props.history.push("/dashboard/accountsettings/billings");
      }, 1000);
    } else {
      this.props.resetSession();
    }
  }

  renderField(field) {
    var {
      meta: { touched, error },
    } = field;
    var className = `form-group login-element ${
      touched && error ? "has-danger" : ""
    }`;
    return (
      <div className={className}>
        <label>{field.label}</label>
        <input
          className="form-control"
          type={field.type}
          placeholder={field.placeholder}
          {...field.input}
        />
        <div className="text-help">{touched ? error : ""}</div>
      </div>
    );
  }

  onFormSubmit(values) {
    this.setState({ loading: true });
    this.props.mainLogin(values, this.props.session, (response) => {
      // this.setState({loading: false});
      if (response.success === 0) {
        this.setState({
          ...this.state,
          alertMessage: LocaleStrings.invalid_email_password,
          showerror: true,
          loading: false,
        });

        setTimeout(
          () =>
            this.setState({
              ...this.state,
              showerror: false,
              alertMessage: "",
            }),
          5000
        );
      } else if (response.success === 2) {
        this.props.history.push("/preview");
      } else if (response.success === 3) {
        // The error is for if user is not admin can't login..
        this.setState({
          ...this.state,
          alertMessage: LocaleStrings.invalid_user,
          showerror: true,
          loading: false,
        });
      } else if (response.success === 4) {
        // The condition is for if user has more than one event.
        if (response && response.clientid) {
          this.props.checkClientuserlimitandexpiry(
            response.clientid,
            this.props.session,
            (response) => {}
          );
        }
        this.setState({ loading: false });
        // Open event chooser Modal
        this.props.initiateCreateEvent({ initiate: false });
        this.props.openEventChooser({ showModal: true });
      } else if (response.success === 101) {
        // Admin Panel access period is expired.
        this.setState({
          ...this.state,
          alertMessage: LocaleStrings.login_user_session_expired,
          showerror: true,
          loading: false,
        });
      } else {
        // The condition is for if user has only one event, then direct goto dashboard
        this.props.history.push("/dashboard");
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal) {
      this.setState({ ...this.state, loading: false });
    }
  }

  render() {
    var { handleSubmit } = this.props;
    // Logo-koachify-white.svg
    return (
      <div className="full-height login-background">
        <div className="login-bar"></div>
        <div className="login-container">
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-2 col-lg-2" />
            <div className="col-md-3 col-lg-3 login-content">
              <div className="horizontal-align-right">
                <img
                  src={
                    DEVELOPMENT_TYPE === "koachify"
                      ? "../../style/images/Logo-koachify-white.svg"
                      : "../../style/images/Logo-White.png"
                  }
                  alt="logo"
                />
              </div>
              <div>&nbsp;</div>
              <div className="horizontal-align-right">
                {LocaleStrings.login_page_paragraph}
              </div>
            </div>
            <div className="col-md-5 col-lg-4 login-form-container">
              {this.state.showerror ? (
                <LoginErrorBar alertMessage={this.state.alertMessage} />
              ) : (
                ""
              )}
              <form onSubmit={handleSubmit(this.onFormSubmit.bind(this))}>
                <div className="row">
                  <div className="col-md-12 col-lg-12">&nbsp;</div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12 form-title horizontal-align-center">
                    {LocaleStrings.login_to_plateform}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">&nbsp;</div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">
                    <Field
                      name="email"
                      label={LocaleStrings.login_form_label_email}
                      placeholder={LocaleStrings.login_form_ph_email}
                      type="email"
                      component={this.renderField}
                    />

                    <Field
                      name="password"
                      label={LocaleStrings.login_form_label_password}
                      type="password"
                      placeholder={LocaleStrings.login_form_ph_password}
                      component={this.renderField}
                    />

                    <div className="form-group login-element top-buffer">
                      <Button
                        className="btn btn-social-login"
                        loading={this.state.loading}
                        type="submit"
                      >
                        {LocaleStrings.button_login}
                      </Button>
                      {/* <button type="submit" className="btn btn-default btn-social-login">Login</button> */}
                    </div>
                    {/* <div className="form-group horizontal-align-center login-light-color">
                      or Login with
                    </div>
                    <div className="form-group horizontal-align-center">
                      <span className="btn btn-link-social btn-link-social-linkedin icon_strech">
                        <i className="fa fa-linkedin"></i>
                      </span>

                      <span className="btn btn-link-social btn-link-social-twitter icon_strech">
                        <i className="fa fa-twitter"></i>
                      </span>

                      <span className="btn btn-link-social btn-link-social-google-plus icon_strech">
                        <i className="fa fa-google-plus"></i>
                      </span>
                    </div> */}
                  </div>
                </div>
                {DEVELOPMENT_TYPE === "koachify" ? (
                  <div className="row">
                    <div className="col-md-12 col-lg-12">&nbsp;</div>
                    <div className="col-md-12 col-lg-12 horizontal-align-center login-multi-color">
                      {LocaleStrings.dont_have_account_text}?{" "}
                      <Link to="/signup">{LocaleStrings.create_here}</Link>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="row">
                  <div className="col-md-12 col-lg-12">&nbsp;</div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12 horizontal-align-center login-multi-color">
                    {LocaleStrings.forgot_password_text}&nbsp;
                    <Link to="/reset">{LocaleStrings.reset_here}</Link>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 col-lg-12">&nbsp;</div>
                </div>
              </form>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12">&nbsp;</div>
          </div>
        </div>
        <EventChooser insideDashBoard={false} history={this.props.history} />
        <ErrorBar />
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  if (!values.email) {
    errors.email = LocaleStrings.login_form_validation_email_required;
  }

  if (!values.password) {
    errors.password = LocaleStrings.login_form_validation_password_required;
  }
  return errors;
}

var mapStateToProps = (state) => ({
  isLoggedIn: state.isLoggedIn,
  user: state.user,
  session: state.session,
  showModal: state.openLoginOTPModal,
});

export default reduxForm({
  validate,
  form: "LoginForm",
})(
  connect(mapStateToProps, {
    mainLogin,
    resetSession,
    openEventChooser,
    initiateCreateEvent,
    logout,
    checkClientuserlimitandexpiry,
  })(Login)
);
